import React from "react";
import "./style.scss";
import {useLocaleContext} from "../../context/LocaleContext";

export default ({partner}) => {
    const {getLocaleProperty} = useLocaleContext();

    if (partner.logoHref) {
        return (
            <a
                href={partner.logoHref}
                target="_blank"
                style={{backgroundColor: `#${partner.backgroundColor}`}}
                className="quiz-partner"
                title={getLocaleProperty(partner, 'title')}
            >
                <div style={{backgroundImage: `url(${partner.logoUrl})`}} />
            </a>
        );
    }

    return (
        <div
            style={{backgroundColor: `#${partner.backgroundColor}`}}
            className="quiz-partner"
            title={getLocaleProperty(partner, 'title')}
        >
            <div style={{backgroundImage: `url(${partner.logoUrl})`}} />
        </div>
    );
}
